var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletBackground3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 72,
    viewBox: "0 0 311 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11449_46711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 311,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 311,
    height: 72,
    rx: 10,
    fill: "url(#paint0_linear_11449_46711)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11449_46711)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.519061 -15.5037C0.107148 -16.338 0.742654 -17.1665 1.38742 -17.9891L98.4202 -74.011C99.4549 -74.1581 100.49 -74.2942 101.526 -74.4193L-0.519061 -15.5037Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.0487 6.15453C-13.7096 5.49191 -13.3654 4.8316 -13.0161 4.17367L124.815 -75.4034C125.56 -75.3769 126.304 -75.3449 127.047 -75.3073L-14.0487 6.15453Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.9785 24.5796C-21.772 23.9955 -21.5619 23.4126 -21.3482 22.831L145.139 -73.2905C145.75 -73.1848 146.36 -73.0753 146.969 -72.9621L-21.9785 24.5796Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.8047 41.2129C-26.6824 40.6783 -26.5571 40.1444 -26.429 39.6112L162.212 -69.3005C162.738 -69.1449 163.263 -68.9865 163.787 -68.8251L-26.8047 41.2129Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.498 56.6146C-29.4373 56.1162 -29.3741 55.6182 -29.3084 55.1205L177.083 -64.0396C177.547 -63.8476 178.01 -63.6533 178.472 -63.4567L-29.498 56.6146Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.5546 71.0715C-30.543 70.6018 -30.5292 70.1323 -30.5132 69.6629L190.279 -57.8117C190.694 -57.5909 191.107 -57.3681 191.52 -57.1433L-30.5546 71.0715Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.266 84.7517C-30.2959 84.3062 -30.3237 83.8607 -30.3495 83.4152L202.107 -50.7938C202.48 -50.5487 202.852 -50.3019 203.223 -50.0533L-30.266 84.7517Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.8181 97.7626C-28.8843 97.3383 -28.9487 96.9139 -29.0112 96.4894L212.761 -43.0977C213.097 -42.8313 213.432 -42.5634 213.767 -42.2939L-28.8181 97.7626Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.3353 110.176C-26.4345 109.771 -26.5319 109.365 -26.6275 108.96L222.369 -34.7981C222.672 -34.5125 222.974 -34.2255 223.276 -33.937L-26.3353 110.176Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.9032 122.041C-23.0329 121.654 -23.1609 121.266 -23.2873 120.878L231.02 -25.9462C231.293 -25.6428 231.565 -25.3381 231.835 -25.0321L-22.9032 122.041Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.581 133.393C-18.7396 133.022 -18.8966 132.651 -19.052 132.28L238.777 -16.5776C239.021 -16.2574 239.263 -15.9359 239.505 -15.6133L-18.581 133.393Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.4093 144.254C-13.5957 143.899 -13.7805 143.544 -13.9638 143.189L245.68 -6.71649C245.896 -6.38011 246.111 -6.04261 246.325 -5.70396L-13.4093 144.254Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.41342 154.639C-7.6267 154.301 -7.83883 153.962 -8.04979 153.621L251.758 3.62142C251.947 3.97422 252.135 4.32748 252.321 4.68116L-7.41342 154.639Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.593484 164.548C-0.834499 164.226 -1.0744 163.903 -1.31317 163.579L257.013 14.4342C257.174 14.8031 257.334 15.1724 257.492 15.5421L-0.593484 164.548Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07607 173.967C6.80624 173.662 6.5375 173.355 6.26986 173.048L261.422 25.7357C261.554 26.1213 261.685 26.5073 261.815 26.8935L7.07607 173.967Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6356 182.872C15.3354 182.584 15.0362 182.296 14.7381 182.005L264.945 37.5483C265.047 37.9515 265.148 38.355 265.247 38.7588L15.6356 182.872Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1445 191.229C24.8116 190.96 24.4796 190.69 24.1487 190.419L267.526 49.9049C267.596 50.3272 267.664 50.7496 267.73 51.1721L25.1445 191.229Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6883 198.988C35.3193 198.741 34.9513 198.492 34.5842 198.241L269.082 62.8532C269.116 63.2965 269.148 63.7398 269.177 64.183L35.6883 198.988Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3915 206.078C46.9815 205.855 46.5724 205.629 46.1643 205.402L269.494 76.4624C269.487 76.9295 269.477 77.3965 269.466 77.8633L47.3915 206.078Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4398 212.391C59.9813 212.196 59.5238 211.999 59.0672 211.799L268.583 90.8353C268.527 91.3306 268.47 91.8255 268.409 92.3201L60.4398 212.391Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1247 217.76C74.6059 217.6 74.0879 217.438 73.5708 217.272L266.071 106.132C265.955 106.663 265.837 107.193 265.716 107.722L75.1247 217.76Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9426 221.897C91.3421 221.785 90.7423 221.67 90.1432 221.551L261.49 122.624C261.294 123.202 261.093 123.779 260.89 124.355L91.9426 221.897Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.864 224.242C111.137 224.205 110.41 224.163 109.684 224.116L253.941 140.829C253.619 141.482 253.292 142.132 252.96 142.78L111.864 224.242Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.386 223.354C136.397 223.474 135.408 223.583 134.418 223.682L241.199 162.033C240.618 162.84 240.028 163.642 239.43 164.438L137.386 223.354Z",
    fill: "#507100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.322 193.706C205.309 197.514 200 201.051 194.404 204.281C188.808 207.512 183.091 210.342 177.286 212.78L210.322 193.706Z",
    fill: "#507100"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46711",
    x1: 21.77,
    y1: 9.02618,
    x2: 42.4742,
    y2: 120.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#92DC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E46E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBackground3);
export default __webpack_public_path__ + "static/media/walletBackground3.aa5bd1d75dd4b50f5ce59b59fd6f9415.svg";
export { ForwardRef as ReactComponent };